import { Event } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/tagManagementSystem/Events";
import { TmsServiceInterface } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/tagManagementSystem/TmsServiceInterface";

const gtmService: TmsServiceInterface = {
  pushToDataLayer(event: Event): void {
    const dl = window.dataLayer;
    if (Array.isArray(dl)) {
      dl.push(event);
    }
  },
};

export default gtmService;

const insertMainGoogleScript = (tagManagerId: string) => {
  const s = "script";
  const l = "dataLayer";

  window[l] = window[l] || [];
  window[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const f = document.getElementsByTagName(s)[0],
    j = document.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.id = "gtmScript";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + tagManagerId + dl;

  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  j.nonce = btoa(String.fromCharCode(...array));
  f?.parentNode?.insertBefore(j, f);
};

export const insertGoogleScripts = (tagManagerId: string): void => {
  // Insert main script
  insertMainGoogleScript(tagManagerId);

  // Insert secondary script inside iframe
  const googleIframe = document.createElement("iframe");
  googleIframe.setAttribute("src", `https://www.googletagmanager.com/ns.html?id=${tagManagerId}`);
  googleIframe.setAttribute("height", "0");
  googleIframe.setAttribute("width", "0");
  googleIframe.setAttribute("style", "display:none;visibility:hidden");
  const appNoScriptElement = document.getElementsByTagName("noscript")[0];
  appNoScriptElement?.prepend(googleIframe);
};

declare global {
  interface Window {
    dataLayer: undefined | Object[];
  }
}
